import storage from "@/store/storage";
import { Notification } from "element-ui";
const app = {
  state: {
    accessToken: storage.getLocalItem("accessToken") || null, // 用户token
    userInfo: storage.getLocalItem("userInfo") || null, // 用户信息
    userAuthName: (storage.getLocalItem("userInfo") || {}).userAuthName || null, // 用户认证姓名
    tenantId: storage.getLocalItem("tenantId") || null, // 用户信息
    deploymentType: storage.getSessionItem("deploymentType") || null, // 部署方式
    role: storage.getLocalItem("role") || null, //PLATFORM //OPERATION //ADMIN
    // role: storage.getLocalItem('role') || 'ADMIN'
  },
  mutations: {
    setToken(state, e) {
      storage.setLocalItem("accessToken", e);
      state.accessToken = e;
    },
    setUserInfo(state, e) {
      const userAuthName = (e && e.userAuthName) || "";
      const normalizedUserInfo = Object.assign({}, e || {}, { userAuthName });
      storage.setLocalItem("userInfo", normalizedUserInfo);
      storage.setLocalItem("tenantId", normalizedUserInfo.tenantId);
      state.userInfo = normalizedUserInfo;
      state.userAuthName = userAuthName;
      state.tenantId = normalizedUserInfo.tenantId;
    },
    setDeploymentType(state, e) {
      storage.setSessionItem("deploymentType", e);
      state.deploymentType = e;
    },
    setRole(state, e) {
      storage.setLocalItem("role", e);
      // storage.setSessionItem('role', e)
      state.role = e;
    },
    logOut(state) {
      state.accessToken = null;
      state.userInfo = null;
      state.userAuthName = null;
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    },
  },
  actions: {
    notification({ commit }, message) {
      Notification.error({
        title: "错误提示",
        message,
        customClass: "error-message",
      });
    },
  },
  getters: {},
};

export default app;
